export default __webpack_public_path__ + "static/door1-b10ffe4eb4bf0f71d4c087be6c821ff7.jpg";